import { render, staticRenderFns } from "./PopupCompany.vue?vue&type=template&id=39b45664&scoped=true"
import script from "./PopupCompany.vue?vue&type=script&lang=js"
export * from "./PopupCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupCompany.vue?vue&type=style&index=0&id=39b45664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b45664",
  null
  
)

export default component.exports